import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Service } from '../../../store/_declarations/target';
import Font from '../../atoms/Font';
import Icon from '../../atoms/Icon';
import ServiceListItem from '../ServicesListItem';
import {
  OptionalServicesListWrapper,
  OptionalServicesTitle,
  OptionalServicesWrapper,
  SelectedSection,
  ServiceWrapper,
  TextSelectionWrapper
} from './styles';

const OptionalServices: FC<{
  callbackOnSelection: (s: string[]) => void;
  list: Service[];
}> = ({ callbackOnSelection, list }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedParents, setSelectedParents] = useState<{
    [key: string]: boolean;
  }>({});

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleParentSelect = (item: Service, checked: boolean) => {
    const selection: {
      [key: string]: boolean;
    } = { ...selectedParents, [item.zzService]: checked };
    setSelectedParents(selection);
    const parsedSelection: string[] = Object.keys(selection).filter(
      (id) => selection[id]
    );

    callbackOnSelection(parsedSelection);
  };

  const selectedCount = Object.values(selectedParents).filter(Boolean).length;

  return (
    <OptionalServicesWrapper>
      <OptionalServicesTitle $isOpen={open}>
        <Font variant="bodyBold">{t('OptionalServicesTitle')}</Font>
        <SelectedSection>
          {selectedCount > 0 && (
            <TextSelectionWrapper>
              <Font variant="bodyBold">{selectedCount}</Font>
              <Font variant="bodyRegular">{t('ServicesSelected')} -</Font>
            </TextSelectionWrapper>
          )}
          <Icon
            iconName={open ? 'InterfaceChevronUp' : 'InterfaceChevronDown'}
            onClick={handleOpen}
          />
        </SelectedSection>
      </OptionalServicesTitle>
      {open && (
        <OptionalServicesListWrapper>
          {list.map((item) => (
            <ServiceWrapper key={item.zzServDesc}>
              <ServiceListItem
                checkboxProps={{
                  callback: handleParentSelect,
                  checked: !!selectedParents[item.zzService]
                }}
                service={item}
              />
            </ServiceWrapper>
          ))}
        </OptionalServicesListWrapper>
      )}
    </OptionalServicesWrapper>
  );
};

export default OptionalServices;
